import { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    LOAD,
    LOAD_END,
    SELECT_TEUDA_DATE,
} from '../../../../../../../store/actions/actionsTypes';
import { RootState } from '../../../../../../../store/reducers/rootReducer';
import { ITeudotItem } from '../../../../../../../models/RequestsModel/teudot';
import { Certificates } from '../../../../../../modules/API/Certificates/certificates';
import { Printouts } from '../../../../../../modules/API/Printouts/printouts';
import { Defaults } from '../../../../../../modules/API/Defaults/defaults';
import { ITableOfTableItem } from '../../../../../../modules/API/Defaults/models/tableOfTables';
import { ITeudotSmsData } from '../../../../../../modules/API/Certificates/models/smsData';
import { ContextModal } from '../../../../../../modules/modal/modalContext';
import selectBrodMigdal from '../../../../../../generic/utils/selectBrodMigdal';
import { addIDForTheList } from '../../../../../../generic/utils/addUIDForTheList';
import useCheckRights from '../../../../../../generic/hooks/useCheckRights';
import usePrint from '../../../../../../generic/hooks/usePrint';
import { TlistInterface, TreqSign } from '../../types/list';
import { filterTeudot } from '../../helpers/filterTeudot';

const useKosherTeudotList = () => {
    const dispatch = useDispatch();
    const [, setModal] = useContext(ContextModal);

    const {
        file: pdfFile,
        setPdfFromBlob,
        handleSharePdf,
        handleDownloadPdf,
        handleOpenPdf,
        handleClearFile: handleClearPdfFile,
    } = usePrint();

    const { hasRight: isDisabledHandleTeudot } = useCheckRights({ key: 'R1001' });
    const { hasRight: isAllowToCreateTeudot } = useCheckRights({ key: 'R1002' });

    const defaults = useSelector((state: RootState) => state.defaults.defaults);
    const { user, workerType } = useSelector((state: RootState) => state.mainReducer);
    const setDefaultDate = useSelector((state: RootState) => state.kosherTeudotReducer.date);

    const isAllowToSendSms = selectBrodMigdal(defaults, 273, 'Text_Value') !== '';

    const isMashgiah = useMemo(() => {
        if (!workerType) return false;
        return workerType === 6;
    }, [workerType]);

    const [date, setDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const dateString = `DateFrom=${date}&DateTo=${endDate}`;

    const [input, setInput] = useState('');
    const [listState, setListState] = useState<TlistInterface>();
    const [filterKoserList, setFilterKosherList] = useState<ITableOfTableItem[]>();
    const [selectedKosherID, setSelectedKosherID] = useState<number>();
    const [selectedTeuda, setSelectedTeuda] = useState<ITeudotItem>();
    const [isOpenPalletLogModal, setIsOpenPalletLogModal] = useState(false);
    const [isOpenSelectByTwo, setIsOpenSelectByTwo] = useState(false);

    const selectedDate = Array.isArray(setDefaultDate)
        ? setDefaultDate
        : new Date(setDefaultDate as string);

    const handleDate = (e: object | object[]) => {
        dispatch({ type: SELECT_TEUDA_DATE, payload: e });
    };

    const getTeudotKosherVariations = async () => {
        try {
            const res = await Defaults.getDataFromTableOfTables(307);
            setFilterKosherList(res);
        } catch (err) {}
    };

    const sendSms = async (data: ITeudotSmsData) => {
        if (!isAllowToSendSms) return;
        dispatch({ type: LOAD });
        try {
            await Certificates.sendCertBySms(data);
            setModal({
                open: true,
                value: 'הודעה נשלחה בהצלחה',
                mood: true,
            });
            setTimeout(() => {
                setModal({
                    open: false,
                    value: '2',
                });
            }, 3000);
        } catch (err: any) {
            console.log(err);
            setModal({
                open: true,
                value:
                    err.response?.data?.error === 'Client has no phone'
                        ? 'לא נמצא מספר טלפון ללקוח'
                        : err.response?.data?.error,
                mood: false,
            });
            setTimeout(() => {
                setModal({
                    open: false,
                    value: '2',
                });
            }, 3000);
        } finally {
            dispatch({ type: LOAD_END });
        }
    };

    const printPdf = async (code: number, sub: number) => {
        dispatch({ type: LOAD });
        try {
            const blob = await Printouts.getTeudaPdf(code, sub);
            setPdfFromBlob(blob, `תעודה-${code}-${sub}.pdf`);
        } catch (e) {
            console.error(e);
        } finally {
            dispatch({ type: LOAD_END });
        }
    };

    const getTeudot = async (dateRange: string, id?: number) => {
        dispatch({ type: LOAD });
        try {
            let res;
            if (id === 0 || !id) {
                res = await Certificates.getCertsByDate(dateRange);
                addIDForTheList(res);
            } else {
                res = await Certificates.getCertsByKosher(dateRange, id);
                addIDForTheList(res);
            }
            setListState({
                current: res,
                default: res,
            });
            console.log(res);
        } catch (err: any) {
            console.log(err.response);
        } finally {
            dispatch({ type: LOAD_END });
        }
    };

    const handleFilterKosher = (id: string) => {
        setSelectedKosherID(+id);
        if (date) {
            getTeudot(dateString, +id);
        }
    };

    const modyfiTeudaAfterSign = (data: any) => {
        const delivery = data.Deliveries;
        if (delivery.length === 1 && listState) {
            const temp = [...listState?.current];
            const found = temp.find(
                (e) =>
                    e.Delivery_Num === delivery[0].Delivery_Num &&
                    e.Delivery_Sub === delivery[0].Delivery_Sub,
            );
            if (found) {
                const indexOfitem = temp.indexOf(found);
                const tempElement = temp.splice(indexOfitem, 1);
                tempElement[0].Mashgiah = data.Mashgiah;
                temp.splice(indexOfitem, 0, tempElement[0]);
                setListState({
                    ...listState,
                    current: temp,
                });
            }
        }
    };

    const setSign = async (item: TreqSign[], mashgiah?: number) => {
        const data = {
            Mashgiah: mashgiah ? 0 : user ? +user.code_internal : 0,
            Deliveries: item,
        };
        try {
            await Certificates.setStamp(data);
            modyfiTeudaAfterSign(data);
        } catch (err: any) {
            console.log(err.response);
            setModal({
                open: true,
                value: err.response?.data?.message,
                mood: false,
            });
            setTimeout(() => {
                setModal({
                    open: false,
                    value: '2',
                });
            }, 3000);
        }
    };

    const printAll = () => {
        const data = listState?.default.reduce((acc: TreqSign[], cur) => {
            if (cur.Mashgiah === 0) {
                const obj = {
                    Delivery_Num: cur.Delivery_Num,
                    Delivery_Sub: cur.Delivery_Sub,
                };
                acc.push(obj);
            }
            return acc;
        }, []);
        if (data) {
            setSign(data).then(() => {
                if (date) {
                    getTeudot(dateString, selectedKosherID);
                }
            });
        }
        setIsOpenSelectByTwo(false);
        console.log(123123123);
    };

    const renderList = useMemo(() => {
        if (!listState) return [];
        return filterTeudot(listState.current, input);
    }, [listState, input]);

    const checkForUnSign = useMemo(() => {
        return listState?.default.find((item) => item.Mashgiah === 0);
    }, [listState]);

    const handleOpenPalletLogModal = (teuda: ITeudotItem) => {
        setSelectedTeuda(teuda);
        setIsOpenPalletLogModal(true);
    };

    const handleStampFilter = () => {
        if (!checkForUnSign) {
            setModal({
                open: true,
                value: '',
                mood: false,
            });
            setTimeout(() => {
                setModal({
                    open: false,
                    value: '2',
                });
            }, 3000);
            return;
        }
        setIsOpenSelectByTwo(!isOpenSelectByTwo);
    };

    useEffect(() => {
        getTeudotKosherVariations();
    }, []);

    useEffect(() => {
        if (!date) return;
        getTeudot(dateString, selectedKosherID);
    }, [dateString]);

    return {
        user,
        isDisabledHandleTeudot,
        isAllowToCreateTeudot,
        isAllowToSendSms,
        isMashgiah,
        setDefaultDate,
        selectedDate,
        setDate,
        setEndDate,
        handleDate,
        input,
        setInput,
        filterKoserList,
        selectedKosherID,
        handleFilterKosher,
        renderList,
        checkForUnSign,
        printPdf,
        pdfFile,
        handleSharePdf,
        handleDownloadPdf,
        handleOpenPdf,
        handleClearPdfFile,
        setSign,
        sendSms,
        printAll,
        handleStampFilter,
        handleOpenPalletLogModal,
        selectedTeuda,
        isOpenPalletLogModal,
        setIsOpenPalletLogModal,
        isOpenSelectByTwo,
        setIsOpenSelectByTwo,
    };
};

export default useKosherTeudotList;
